// spell-checker:ignore colorpicker

export class SliderPosition {
  constructor(
    public hue: number,
    public saturation: number,
    public value: number,
    public alpha: number) { }
}
export class SliderDimension {
  constructor(
    public hue: number,
    public saturation: number,
    public value: number,
    public alpha: number) { }
}
